<template>
  <div class="class_create">
    <div class="header">
      请填写班级信息
    </div>
    <div class="content_box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="班级封面" prop="c_ico">
          <div style="display: flex; align-items: center;">
            <el-upload class="avatar-uploader" :headers="headerParam" action="/jd/uploadClassImg" :show-file-list="false" :on-success="handleAvatarSuccess" name="image" :before-upload="beforeAvatarUpload">
              <img v-if="ruleForm.c_ico" :src="ruleForm.c_ico" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-popover placement="bottom" width="330" trigger="click">
              <div class="image_box">
                <div class="image_item" v-for="item in image_list" :key="item" @click="selectImage(item)">
                  <img :src="item" alt="">
                </div>

              </div>
              <el-button slot="reference" style=" width: 88px;height: 36px; display: flex;margin-left: 20px;border: 1px solid #DCDCDC;align-items: center;justify-content: center;">备选封面</el-button>
            </el-popover>

          </div>
        </el-form-item>
        <el-form-item label="班级名称" prop="c_name">
          <el-input v-model="ruleForm.c_name"></el-input>
        </el-form-item>
        <el-form-item label="课程选择" prop="course_ids">
          <div class="course_box">
            <div class="course_list" :class="item.isSelect?'select_course_list':''" v-for="(item,index) in teacherCourseList" :key="item.course_id" @click="selectCourse(item,index)">
              {{ item.course_name }}
              <i v-show="item.isSelect" class="el-icon-success icon"></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="button_box">
        <el-button @click="cancle">取消</el-button>
        <el-button style="background: #4F7BFD;color: #fff;" @click="confirm('ruleForm')">确定</el-button>
      </div>
    </div>
  </div>

</template>
  
  <script>
export default {
  data() {
    return {
      teacherCourseList: [], //课程目录
      ruleForm: {
        c_name: "",
        c_ico: "",
        course_ids: "",
        c_id: this.$route.query.c_id || "",
      },
      headerParam: {
        Authorization: null,
      },
      rules: {
        c_name: [
          { required: true, message: "请输入班级名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        course_ids: [
          { required: true, message: "请输入选择课程", trigger: "change" },
        ],
      },
      image_list: [],
    };
  },
  mounted() {
    this.headerParam.Authorization = localStorage.getItem("sToken");
    this.getTeacherCourseList();
    this.getImages();
  },
  methods: {
    getTeacherCourseList() {
      this.$thttp.axiosGet(this.$api.admin_sclAdminCourseList, (res) => {
        if (res.code === 200) {
          this.teacherCourseList = res.data.course_list.map((item) => {
            return {
              ...item,
              isSelect: false,
            };
          });
          if (this.$route.query.c_name) {
            this.ruleForm.c_name = this.$route.query.c_name;
            this.ruleForm.c_ico = this.$route.query.c_ico;
            let arr = this.$route.query.course_ids.split(",");
            arr.forEach((item) => {
              this.teacherCourseList.forEach((data) => {
                if (data.course_id == item) {
                  data.isSelect = true;
                }
              });
            });
          }
        }
      });
    },
    handleAvatarSuccess(res) {
      if (res.code == 200) {
        this.ruleForm.c_ico = res.data.url;
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.data);
      }
    },
    beforeAvatarUpload() {},
    selectCourse(data, index) {
      this.teacherCourseList.forEach((item) => {
        if (data.course_id == item.course_id) {
          item.isSelect = !item.isSelect;
        }
      });
    },
    confirm(formName) {
      // 确认
      let arr = this.teacherCourseList.filter((item) => item.isSelect);
      if (arr.length == 0) {
        this.$message.warning("请至少选择一个课程!");
        return;
      }
      this.ruleForm.course_ids = arr.map((item) => item.course_id).join(",");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$shttp.axiosPost(
            this.$api.jdSaveClass,
            this.ruleForm,
            (res) => {
              if (res.code == 200) {
                if (this.$route.query.c_id) {
                  this.$message.success("编辑成功");
                } else {
                  this.$message.success("创建成功");
                }
                this.$router.push("/qualityCourse/educational");
              }
            },
            (err) => {
              console.log(err);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancle() {
      // 取消
      this.$router.push("/qualityCourse/educational");
    },
    // jdClassCoverList
    getImages() {
      this.$shttp.axiosGetBy(this.$api.jdClassCoverList, {}, (res) => {
        if (res.code === 200) {
          this.image_list = res.data;
        }
      });
    },
    // ruleForm.c_ico
    selectImage(item) {
      this.ruleForm.c_ico = item;
    },
  },
};
</script>
  
  <style scoped lang="scss">
.class_create {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 30px 18.75% 20px 18.75%;
  box-sizing: border-box;
  .header {
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    border-bottom: 1px solid #eaecf1;
    height: 51px;
    padding-left: 20px;
    box-sizing: border-box;
  }
  .content_box {
    width: 600px;
    padding-top: 50px;
    margin: 0 auto;
  }
}
.avatar-uploader {
  // border: 1px dashed #d57676;
}
::v-deep .avatar-uploader-icon[data-v-2a507d1d] {
  border: 1px solid #dcdcdc;
}
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: red;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #333;
  width: 200px;
  height: 120px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar {
  width: 200px;
  height: 120px;
  display: block;
  object-fit: cover;
  border-radius: 8px 8px 8px 8px;
}
.course_box {
  width: 500px;
  min-height: 120px;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  box-sizing: border-box;
  .course_list {
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdcdc;
    height: 22px;
    line-height: 22px;
    padding: 2px 13px;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    .icon {
      position: absolute;
      font-size: 10px;
      color: #4f7bfd;
      bottom: 2px;
      right: 2px;
    }
  }
  .select_course_list {
    border: 1px solid #4f7bfd;
  }
}
.button_box {
  display: flex;
  justify-content: center;
  .el-button {
    width: 88px;
    height: 36px;
    background: #f2f4f7;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3e3e3e;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
.image_box {
  width: 330px;
  height: 300px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-y: auto;
  .image_item {
    width: 100px;
    height: 60px;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
/* 设置滚动条整体 */
::-webkit-scrollbar {
  width: 3px; /* 滚动条宽度 */
  height: 6px; /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c3c1c1; /* 滑块背景色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #989797; /* 滑块悬停背景色 */
}
</style>